/**
 * Cancel token.
 */
export enum CancelRequestError {
  CancelToken = 'cancel-token',
}
